import { render } from "./v404.vue?vue&type=template&id=de5cfa00&scoped=true"
import script from "./v404.vue?vue&type=script&lang=js"
export * from "./v404.vue?vue&type=script&lang=js"

import "./v404.vue?vue&type=style&index=0&id=de5cfa00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5cfa00"]])

export default __exports__